<div class="user-area">
  <app-user-menu></app-user-menu>

  <section>
    <router-outlet (activate)="onActivate()"></router-outlet>
  </section>
</div>
